// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icloud-ui-pro-table-operations-wrapper{display:flex;flex-wrap:wrap}.icloud-ui-pro-table-operations-wrapper>*{padding-right:10px}.icloud-ui-pro-table-operations-wrapper>:last-child{padding-right:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
